export const PASSWORD_FIELDS = [
  { key: 'length', label: 'Минимальная длина', min: 1 },
  { key: 'mtLatinUpperCase', label: 'Прописных латинских букв', min: 0 },
  { key: 'mtLatinLowerCase', label: 'Строчных латинских букв', min: 0 },
  { key: 'mtAsciiDigits', label: 'Цифр', min: 0 },
  { key: 'mtSpecialChars', label: 'Специальных символов', min: 0 },
  {
    key: 'passwordHistory',
    label: 'Число предыдущих паролей, запрещённых к повтору',
    min: 1,
  },
  { key: 'forceExpiredPasswordChange', label: 'Срок пароля, дней', min: 1 },
];

const parameter = (key: string) =>
  new RegExp(`(^| and )${key}\\((\\d+)\\)(?= and |$)`);

export function readPasswordPolicy(policy: string): Record<string, number> {
  return Object.fromEntries(
    PASSWORD_FIELDS.map((field) => [
      field.key,
      policy?.match(parameter(field.key))
        ? Number(policy.match(parameter(field.key))[2])
        : null,
    ]),
  );
}

// Update only controls owned by this form. In particular, keep the server's
// alphabet validator and any additional policies installed by an operator.
export function updatePasswordPolicy(
  policy: string,
  values: Record<string, number>,
): string {
  for (const { key } of PASSWORD_FIELDS) {
    if (values[key] == null) continue;
    const value = `${key}(${values[key]})`;
    policy = parameter(key).test(policy)
      ? policy.replace(
          parameter(key),
          (_match, separator: string) => separator + value,
        )
      : [policy, value].filter(Boolean).join(' and ');
  }
  return policy;
}
